import { render, staticRenderFns } from "./ConsultaArquivo.vue?vue&type=template&id=79c74e25&scoped=true"
import script from "./ConsultaArquivo.vue?vue&type=script&lang=js"
export * from "./ConsultaArquivo.vue?vue&type=script&lang=js"
import style0 from "./ConsultaArquivo.vue?vue&type=style&index=0&id=79c74e25&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79c74e25",
  null
  
)

export default component.exports